module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/service.json
// module id = 724
// module chunks = 252162280564942